module.exports = __webpack_public_path__ + "9079eef0f46026093f16095a76e3f364.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/winking-s.png
// module id = 2304
// module chunks = 0